var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"results-table__compare--btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToCreditParams($event)}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }